import { render, staticRenderFns } from "./DisabledTable.vue?vue&type=template&id=d650c78a"
import script from "./DisabledTable.vue?vue&type=script&lang=js"
export * from "./DisabledTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports